import { getAmount } from 'utility/functions';
import styles from './CustomTooltip.module.scss';

export interface CustomTooltipProps {
  active?: boolean;
  payload: any;
  currPlaytimeFilter: any;
  timeFormatter: Function;
}

const CustomTooltip = ({ active, payload, currPlaytimeFilter, timeFormatter }: CustomTooltipProps) => {
  const formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
  });
  // console.log('currPlaytimeFilter', currPlaytimeFilter);
  if (active && payload && payload.length) {
    return (
      <div className={styles.customTooltip}>
        <div className={styles.tooltipDetails}>
          <p className={styles.label}>{payload[0].payload.verticale}</p>
          {currPlaytimeFilter.value === 'importoTot' ? (
            <p>{formatter.format(getAmount(payload[0].payload.importoTot))}</p>
          ) : (
            <p>{timeFormatter(payload[0].payload.tempoTot)}</p>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
